module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahead1-295ea8d7f38a3148efe558231e4397e3.jpg";